var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-flag"},[(_vm.code)?_c('img',{staticClass:"icon-flag__image",attrs:{"title":_vm.title || _vm.alt,"src":_vm.src,"alt":_vm.alt}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }